var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnChanges } from '@angular/core';
import { RefDetailComponent } from "./ref_detail.component";
import { FilterParams } from "app/models/filter_form.model";
import merge from "lodash-es/merge";
import { RefService } from "./ref.service";
import { HelperService } from "app/lib/helper.service";
import { ModalService } from "../modal/base_modal.component";
import dictionary from "dict/static.json";
import { FilterFormService } from "../filter_form/filter_form.service";
import { ActivatedRoute } from "@angular/router";
var RefComponent = /** @class */ (function () {
    function RefComponent(refService, modalService, helper, filter, activatedRoute) {
        var _this = this;
        this.refService = refService;
        this.modalService = modalService;
        this.helper = helper;
        this.filter = filter;
        this.activatedRoute = activatedRoute;
        this.isDesc = false;
        this.direction = -1;
        this.refLoader = false;
        this.itemLoader = [];
        this.refererType = 'first';
        this.currencyType = 'all';
        this.dateType = 'dateCreated';
        this.Math = Math;
        this.dictionary = dictionary;
        this.activatedRoute.queryParams.subscribe(function () {
            var _a = _this.filter.filterParams, refererType = _a.refererType, refExtendedFilters = _a.refExtendedFilters, refererFilterType = _a.refererFilterType;
            if (refererFilterType === 'extended' &&
                refExtendedFilters[0] &&
                _this.refererType !== refExtendedFilters[0].refererType) {
                _this.refererType = refExtendedFilters[0].refererType;
            }
            else if (_this.refererType !== refererType) {
                _this.refererType = _this.filter.filterParams.refererType;
            }
        });
    }
    Object.defineProperty(RefComponent.prototype, "currencyList", {
        get: function () { return this.dictionary.currencyList; },
        enumerable: true,
        configurable: true
    });
    RefComponent.prototype.ngOnChanges = function (changes) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!changes.stats) return [3 /*break*/, 2];
                        if (this.filterParams.isRegDay) {
                            this.column = 'countReg';
                        }
                        else if (this.filterParams.isBilling) {
                            this.column = 'moneyCount';
                        }
                        else if (this.filterParams.isDomainBilling) {
                            this.column = 'userCount';
                        }
                        if (this.filterParams.isBilling || this.filterParams.isDomainBilling) {
                            this.dateType = 'datePaid';
                        }
                        else if (this.filterParams.isRegDay) {
                            this.dateType = 'dateCreated';
                        }
                        // ПРОБЛЕМА: В таком варианте список рефереров по всем дням грузится почти одновременно (параллельно). А хотелось бы последовательно. - Vlad Sergeev.
                        return [4 /*yield*/, this.getReferers()];
                    case 1:
                        // ПРОБЛЕМА: В таком варианте список рефереров по всем дням грузится почти одновременно (параллельно). А хотелось бы последовательно. - Vlad Sergeev.
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    RefComponent.prototype.getReferers = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.refLoader = true;
                        _a = this.stats;
                        return [4 /*yield*/, this.refService.getRefs(this.filterParams, {
                                groupDate: this.stats.groupDate,
                                dateType: this.dateType,
                                currencyType: this.currencyType,
                                refererType: this.refererType,
                            }).toPromise()];
                    case 1:
                        _a.refs = _b.sent();
                        this.refLoader = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    RefComponent.prototype.sort = function (property) {
        // Удалить из массива подгруппы
        this.stats.refs = this.stats.refs.filter(function (groupRef) {
            return !groupRef.subGroup;
        });
        // Закрыть раскрытые группы при сортировке
        this.stats.refs.forEach(function (ref) {
            ref.opened = false;
        });
        this.isDesc = !this.isDesc; //change the direction
        this.column = property;
        this.direction = this.isDesc ? 1 : -1;
    };
    RefComponent.prototype.showRefExpand = function (ref, refIndex) {
        return __awaiter(this, void 0, void 0, function () {
            var me_1, groupRefs;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!ref.isGroup || ref.refGroup)
                            return [2 /*return*/, true];
                        if (!!ref.opened) return [3 /*break*/, 2];
                        ref.opened = true;
                        me_1 = this, groupRefs = void 0;
                        if (!ref.subRefs)
                            ref.subRefs = 0;
                        this.itemLoader[refIndex] = true;
                        return [4 /*yield*/, this.refService.getRefs(this.filterParams, {
                                groupDate: this.stats.groupDate,
                                inGroup: ref.ref,
                                dateType: this.dateType,
                                currencyType: this.currencyType,
                                refererType: this.refererType,
                                isGroup: ref.isGroup,
                            }).toPromise()];
                    case 1:
                        groupRefs = _a.sent();
                        groupRefs.forEach(function (groupRef, i) {
                            ref.subRefs++;
                            groupRef.isGroup = false;
                            groupRef.refGroup = ref.ref;
                            groupRef.subGroup = true;
                            groupRef.refererType = me_1.refererType;
                            groupRef.currencyType = me_1.currencyType;
                            me_1.stats.refs.splice(refIndex + 1 + i, 0, groupRef);
                        });
                        this.itemLoader[refIndex] = false;
                        return [3 /*break*/, 3];
                    case 2:
                        ref.opened = false;
                        this.stats.refs.splice(refIndex + 1, ref.subRefs);
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    RefComponent.prototype.showRefDetails = function (ref, refIndex) {
        return __awaiter(this, void 0, void 0, function () {
            var details, reportType, refGroup, refSource, params;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.filterParams.isRegDay) {
                            reportType = 'reg_day';
                        }
                        else if (this.filterParams.isBilling) {
                            reportType = 'billing';
                        }
                        else if (this.filterParams.isDomainBilling) {
                            reportType = 'domain';
                        }
                        if (ref.ref == 'Direct' || ref.ref == 'Referral' || ref.ref == 'Ungrouped') {
                            refGroup = ref.ref;
                        }
                        else {
                            refGroup = ref.refGroup;
                            refSource = ref.ref;
                        }
                        params = merge({}, this.filterParams, {
                            dateTime: this.stats.groupDate,
                            reportType: reportType,
                            refGroup: refGroup,
                            refSource: refSource,
                            refererType: this.refererType
                        });
                        this.itemLoader[refIndex] = true;
                        return [4 /*yield*/, this.refService.getRefDetails(params).toPromise()];
                    case 1:
                        details = _a.sent();
                        this.itemLoader[refIndex] = false;
                        this.modalService.open(RefDetailComponent, {
                            title: (refSource && refSource !== 'all') ? (refGroup + ' - ' + refSource) : (refGroup),
                            stats: details
                        }, { size: 'hg' });
                        return [2 /*return*/];
                }
            });
        });
    };
    return RefComponent;
}());
export { RefComponent };
